document.addEventListener("DOMContentLoaded", () => {
  const $ = (s) => document.querySelector(s);

  const loader = $(".p-loader");
  const loading = $(".p-loading");
  const text = $(".p-loading__text");
  const logo = $(".p-loading__logo");
  const fvTitle = $(".p-fv__title");
  const fvTitleSub = $(".p-fv__title-sub");
  const fvVideo = [$(".p-fixed__video"), $(".p-fv__video")].filter(Boolean);
  const scroll = $(".p-fv__scroll");
  const header = $(".p-header");

  /* --- 24時間以内 or 同一セッション内: ローディングスキップ --- */
  const LOADING_INTERVAL = 24 * 60 * 60 * 1000;
  const lastShown = localStorage.getItem("loading-shown-at");
  const isWithin24h = lastShown && Date.now() - Number(lastShown) < LOADING_INTERVAL;

  if (!loading || isWithin24h || sessionStorage.getItem("loading-played")) {
    if (loader) {
      loader.classList.add("is-loaded");
      loader.style.display = "none";
    }
    if (loading) {
      loading.classList.add("--end");
    }
    // 別ページからのアンカー用: 他スクリプトの DOMContentLoaded リスナー登録後に発火させる
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("page-ready-for-hash"));
    }, 0);
    return;
  }

  /* --- ローディング発火 --- */
  sessionStorage.setItem("loading-played", "1");

  /* スクロール禁止 (iOS Safari対応) ※アンカーリンクの場合はTOP0からスムーススクロールするため0を保持 */
  const scrollY = location.hash ? 0 : window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";
  document.body.style.overflow = "hidden";
  const preventScroll = (e) => e.preventDefault();
  document.addEventListener("touchmove", preventScroll, { passive: false });

  /* 即時: ready 付与 */
  [fvTitle, fvTitleSub, ...fvVideo, scroll, header].forEach((el) => {
    if (el) el.classList.add("--ready");
  });

  /* タイムライン定義 */
  const INITIAL_DELAY = 800;
  const timeline = [
    { delay: INITIAL_DELAY, targets: [[text, "--animate"]] },
    {
      delay: 2800,
      targets: [
        [text, "--end"],
        [logo, "--animate"],
      ],
    },
    { delay: 4300, targets: [[loading, "--animate"]] },
    { delay: 5300, targets: [[fvTitle, "--animate"]] },
    { delay: 5600, targets: [[fvTitleSub, "--animate"]] },
    { delay: 5900, targets: [[loading, "--end"]] },
    { delay: 5900, targets: fvVideo.map((el) => [el, "--animate"]) },
    {
      delay: 6800,
      targets: [
        [header, "--animate"],
        [scroll, "--animate"],
      ],
    },
    {
      delay: 7600,
      remove: [
        [header, "--animate"],
        [header, "--ready"],
      ],
    },
  ];

  timeline.forEach(({ delay, targets, remove }) => {
    setTimeout(() => {
      if (targets) {
        targets.forEach(([el, className]) => {
          if (el) el.classList.add(className);
        });
      }
      if (remove) {
        remove.forEach(([el, className]) => {
          if (el) el.classList.remove(className);
        });
      }
    }, delay);
  });

  /* アニメーション完了後: スクロール解除 + 状態保存 */
  const lastDelay = timeline[timeline.length - 1].delay;
  setTimeout(() => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollY);
    document.removeEventListener("touchmove", preventScroll);

    if (loader) {
      loader.classList.add("is-loaded");
      loader.style.display = "none";
    }
    localStorage.setItem("loading-shown-at", String(Date.now()));
    // 別ページからのアンカー用: script.js のリスナーが確実に反応するよう次ティックで発火
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("page-ready-for-hash"));
    }, 0);
  }, lastDelay);
});
